import { LoadingOrb } from "@/ui";

import styles from "./ErrorScreen.module.css";

/** Shown while a page's code loads (pages are split per route). */
export function PageLoading() {
  return (
    <div className={styles.screen}>
      <LoadingOrb label="Loading" activity="connecting" size="page" />
    </div>
  );
}
